import { FC } from 'react';

import styles from './InputErrorMessage.module.scss';

interface InputErrorMessageProps {
  error: string | boolean | undefined;
}

const InputErrorMessage: FC<InputErrorMessageProps> = ({ error }) => {
  return (
    <>
      {typeof error === 'string' && error.length && (
        <div role="alert" className={styles.text}>
          {error}
        </div>
      )}
    </>
  );
};

export default InputErrorMessage;
